import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';

import ChartThemeProvider from '#providers/ChartThemeProvider';
import ThemeProvider from './providers/ThemeProvider';
import App from './App';

// eslint-disable-next-line no-process-env
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const { worker } = require('./mocks');

  worker.start({
    serviceWorker: {
      url: '/datapoints/mockServiceWorker.js',
    },
  });

  if (window.location.hostname === 'localhost') {
    window.location.replace(
      'https://www.timeshighereducation.local/datapoints/',
    );
  }
}

ReactDOM.render(
  <>
    <ThemeProvider>
      <ChartThemeProvider>
        <App />
      </ChartThemeProvider>
    </ThemeProvider>
  </>,
  document.getElementById('root'),
);
